<script setup lang="ts">
defineProps<{
  visible: boolean
  referenceCode: string
}>()
</script>

<template>
  <fieldset id="applicationCompleteDiv" :class="{ hidden: !visible }">
    <legend>
      <h1>La Trobe University Advanced Standing Application</h1>
    </legend>

    <p>
      Thank you for submitting your Advanced Standing application, your reference number is <b><span id="ReferenceCode">{{ referenceCode }}</span></b>.<br>
    </p>
    <p>
      Please check your student email for the confirmation email. You will be contacted by the University via this email if further information is required.
    </p>
    <p>
      <b>If you receive government benefits, </b>
      you must update
      <a target="_blank" href="https://latrobe-current.custhelp.com/app/answers/detail/a_id/2408" rel="noreferrer">
        Services Australia (also known as Centrelink)
      </a>
      of any changes
      to your personal details or study load as soon as possible.
      This will ensure that you receive the correct benefits and avoid payment issues.
    </p>
    <p>
      Your application will generally be processed by Admissions within 10 working days of the submission. If additional time is required, you will be informed of any delays.
    </p>
  </fieldset>
</template>
